
























import {Component, Prop, Vue} from 'vue-property-decorator'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'

@Component({})
export default class ToggleButtonOrbit extends Vue {
  @Prop({type: Object, required: true}) collection!: OrbitProjectCollection

  get value(): boolean {
    return !!this.collection.onlyRunningOrNullRound
  }

  changeValue() {
    const newValue = !this.value
    this.collection.showOnlyRunningOrNullRound(newValue)
    this.$emit('active', newValue)
  }
}
